import { select } from "d3-selection";

import position from "./position";
import "d3-transition";

export default class Tooltip {
  constructor({ main, opts }) {
    this._ = main;
    const { el, buildTooltipHTML, hoverBlockedRight } = opts;

    // default variables
    this.tooltipContent = el.querySelector(".tooltip");
    this.content = this.tooltipContent.querySelector(".tooltip-content");
    this.close = this.tooltipContent.querySelector(".x-close");
    this.hoverBlockedRight = false;
    this.hoverId = null;
    this.closeCallback = null;
    this.closeContext = null;
    this._isTouch = "ontouchstart" in window || navigator.maxTouchPoints > 0;
    this._allowClose = true; // En táctil, solo true cuando se pulsa la X

    this.buildHTML = buildTooltipHTML;

    if (hoverBlockedRight === true) {
      this.hoverBlockedRight = hoverBlockedRight;

      if (this._.sizes.isDesktop === true) {
        this.tooltipContent.classList.add("fixed-right");
      }
    }

    if (!this.tooltipContent) {
      createEl.call(this);
    }

    // Usar event delegation para el botón cerrar
    this.setupCloseEventDelegation();

    return this;
  }

  createEl() {
    const tooltip = document.createElement("div");
    tooltip.classList.add("tooltip");
    el.appendChild(tooltip);
    this.tooltipContent = tooltip;
  }

  mouseleave(force = false) {
    // Si el tooltip no está activo, no hay nada que cerrar
    const isActive = this.tooltipContent.classList.contains("active");
    if (!isActive) {
      return true; // Ya está cerrado
    }

    // En dispositivos táctiles: SOLO cerrar si force=true (botón X) o _allowClose=true
    // Esto evita completamente el problema de iOS donde eventos espurios cierran el tooltip
    if (this._isTouch && !force && !this._allowClose) {
      return false;
    }

    this.tooltipContent.classList.remove("active");
    this.hoverId = null;
    this._lastRenderedContent = null;
    this._cachedHeight = null;
    this._allowClose = false; // Resetear para el próximo tooltip
    if (!this._.sizes.isDesktop) {
      this.tweenHeight(false);
    }
    return true;
  }

  hover(featureId, featureData, hoveredFeature, e) {
    this.mouseover(e);
    if (featureId !== hoveredFeature.id) {
      this.mouseenter(featureData, featureId);
    }
  }

  mouseover(e) {
    const settings = this._.settings.getSettings();
    if (!this._.sizes.isDesktop) {
    } else {
      if (settings.hoverBlockedRight === false)
        position.call(this, e, this._.el);
    }
  }

  mouseoverBlockedRight() {
    // this function does nothing
    return;
  }

  getHeaderTextColor(d, color) {
    let colorInt = color.replace("#", "");
    const r = parseInt(colorInt.substring(0, 2), 16);
    const g = parseInt(colorInt.substring(2, 4), 16);
    const b = parseInt(colorInt.substring(4, 6), 16);

    const yiq = (r * 299 + g * 587 + b * 114) / 1000;
    return yiq >= 150 ? "#333" : "white";
  }

  mouseenter(...d) {
    const buildHTML = this.buildHTML;
    const content = d[0];
    const id = d[1];

    this.tooltipContent.classList.add("active");
    this._allowClose = false; // En táctil, bloquear cierre hasta que se pulse la X

    // Optimización: solo actualizar innerHTML si el contenido cambió
    const newHTML = buildHTML.call(this._, id, content);
    if (this._lastRenderedContent !== newHTML) {
      this.content.innerHTML = newHTML;
      this._lastRenderedContent = newHTML;
      this._cachedHeight = null;
    }
    this.tweenHeight.call(this, true);
  }

  setupCloseEventDelegation() {
    // Usar event delegation para manejar clics en el botón cerrar
    // Esto funciona incluso cuando el contenido se regenera dinámicamente
    this.tooltipContent.addEventListener("click", (e) => {
      const closeButton = e.target.closest(".x-close");
      if (closeButton && this.closeCallback) {
        e.preventDefault();
        e.stopPropagation();
        this._allowClose = true; // Permitir cierre al pulsar X
        this.closeCallback.call(this.closeContext);
      }
    });
  }

  addCloseEvent(callback, context) {
    // Almacenar el callback y contexto para usarlo con event delegation
    this.closeCallback = callback;
    this.closeContext = context;
  }

  tweenHeight(bool) {
    if (this._.sizes.isDesktop) return;
    const minHeight = 0;

    const topHeight = this.tooltipContent
      .querySelector(".tooltip-content")
      .getBoundingClientRect().height;

    const r = bool ? topHeight : minHeight;

    select(this.tooltipContent)
      .classed("active", bool)
      .transition()
      .duration(400)
      .tween("height", (ev, i, [el], j) => {
        const e = select(this.tooltipContent).node().clientHeight;
        const n = select(el);

        return (t) => {
          n.style("height", e * (1 - t) + r * t + "px");
        };
      });
  }
}
